import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useToastError } from '~/utils/useToastError';
import {
  FoodPersonForm,
  FoodPersonFormValues,
} from '~/components/FoodPersonForm/FoodPersonForm';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import styles from './CreateFoodPerson.module.scss';
import { useTranslation } from 'react-i18next';

const CreateFoodPerson = () => {
  const { foodID } = useParams();
  const navigate = useNavigate();
  const toastError = useToastError();
  const { t } = useTranslation();

  const client = useQueryClient();

  const { mutateAsync: createFoodPerson } = useMutation(
    async ({
      name,
      patronymic,
      position,
      email,
      phone,
    }: FoodPersonFormValues) => {
      const response = await instance.post('admin/food-person', {
        name,
        patronymic,
        position: String(position.id),
        email,
        phone,
        food_id: foodID,
      });
      return response.data;
    },
    {
      onSuccess: (data: FoodPersonFormValues) => {
        client.setQueryData(
          ['food'],
          (oldFoodPerson?: FoodPersonFormValues[]) => {
            if (!oldFoodPerson) {
              return [data];
            }
            return [...oldFoodPerson, data];
          }
        );
        navigate(`/food/${foodID}`);
      },
      onError: error => {
        toastError(error);
      },
    }
  );

  return (
    <Page
      heading={
        <Heading
          text={t('manager_person_creation')}
          classNameText={styles.title}
        />
      }
    >
      <FoodPersonForm
        onSubmit={values => createFoodPerson(values)}
        storageKey="create-food-person"
      />
    </Page>
  );
};

export default CreateFoodPerson;
